import React from 'react';
import { useSelector } from 'react-redux';
import { fetchJson } from '../../../helpers';
import { useQuery } from '@tanstack/react-query';
import {
    monitoring_dashboard_list_reports_path
} from '~/routes';

export const useReportOptions = () => {
    const projectId = useSelector(state => state.dashboard.projectId);
    const {data, isLoading, error} = useQuery({
        queryKey: ['reportOptions', projectId],
        queryFn: async () => fetchJson(monitoring_dashboard_list_reports_path({project_id: projectId, format: "json"})),
        enabled: !!projectId,
    })
    return {data: data || [], isLoading, error}
}
